<template>
  <v-dialog v-model="open" persistent max-width="450">
    <v-card>
      <v-card-title>Billing Contact</v-card-title>

      <v-card-text>
        <v-row>
          <v-col>
            <v-text-field label="First Name" :disabled="getIsUpdateAccountLoading" v-model="first_name" :error-messages="firstNameErrors" :hide-details="firstNameErrors.length===0" @input="$v.first_name.$touch()" @blur="$v.first_name.$touch()" outlined dense class="mb-0"></v-text-field>
          </v-col>
          <v-col>
            <v-text-field label="Last Name" :disabled="getIsUpdateAccountLoading" v-model="last_name" :error-messages="lastNameErrors" :hide-details="lastNameErrors.length===0" @input="$v.last_name.$touch()" @blur="$v.last_name.$touch()" outlined dense class="mb-0"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field label="Email Address" :disabled="getIsUpdateAccountLoading" v-model="email" :error-messages="emailErrors" :hide-details="emailErrors.length===0" @input="$v.email.$touch()" @blur="$v.email.$touch()" outlined dense class="mb-0"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field label="Phone Number" :disabled="getIsUpdateAccountLoading" v-model="phone_number" :error-messages="phoneErrors" :hide-details="phoneErrors.length===0" @input="$v.phone_number.$touch()" @blur="$v.phone_number.$touch()" outlined dense class="mb-0"></v-text-field>
          </v-col>
          <v-col>
            <v-text-field label="Mobile Number" :disabled="getIsUpdateAccountLoading" v-model="mobile_number" :error-messages="mobileErrors" :hide-details="mobileErrors.length===0" @input="$v.mobile_number.$touch()" @blur="$v.mobile_number.$touch()" outlined dense class="mb-0"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-divider></v-divider>
          </v-col>
        </v-row>
        <p class="mb-0">Authorised Contact (Optional)</p>
        <v-row>
          <v-col>
            <v-text-field label="Full Name" :disabled="getIsUpdateAccountLoading" v-model="auth_full_name" hide-details outlined dense class="mb-0"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field label="Email Address" :disabled="getIsUpdateAccountLoading" v-model="auth_email" hide-details outlined dense class="mb-0"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field label="Phone Number" :disabled="getIsUpdateAccountLoading" v-model="auth_phone_number" hide-details outlined dense class="mb-0"></v-text-field>
          </v-col>
          <v-col>
            <v-text-field label="Mobile Number" :disabled="getIsUpdateAccountLoading" v-model="auth_mobile_number" hide-details outlined dense class="mb-0"></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small :disabled="getIsUpdateAccountLoading" :loading="getIsUpdateAccountLoading" @click="save">Save</v-btn>
        <v-btn color="primary" small outlined :disabled="getIsUpdateAccountLoading" @click="closeDialog">cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import { phoneNumberValidation } from "../../validators";
import { emailDomainLowerCase } from "@/helpers";

export default {
  mixins: [validationMixin],

  validations: {
    first_name: { required },
    last_name: { required },
    email: { required, email, emailDomainLowerCase },
    phone_number: { required, phoneNumberValidation },
    mobile_number: { required, phoneNumberValidation },
  },

  data: () => ({
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    mobile_number: "",
    auth_full_name: "",
    auth_last_name: "",
    auth_email: "",
    auth_phone_number: "",
    auth_mobile_number: "",
  }),

  props: {
    open: Boolean,
    close: Function,
    account: Object
  },

  computed: {
    ...mapGetters("accounts", ["getIsUpdateAccountLoading", "getIsUpdateAccountError"]),

    firstNameErrors() {
      const errors = [];
      if (!this.$v.first_name.$dirty) return errors;
      !this.$v.first_name.required && errors.push("First name is a required field");
      return errors;
    },
    
    lastNameErrors() {
      const errors = [];
      if (!this.$v.last_name.$dirty) return errors;
      !this.$v.last_name.required && errors.push("Last name is a required field");
      return errors;
    },

    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.required && errors.push("Email is a required field");
      !this.$v.email.emailDomainLowerCase && errors.push("Email domain must be lowercase");
      !this.$v.email.email && errors.push("Must be valid e-mail");
      return errors;
    },

    phoneErrors() {
      const errors = [];
      if (!this.$v.phone_number.$dirty) return errors;
      !this.$v.phone_number.required && errors.push("Phone number is a required field");
      !this.$v.phone_number.phoneNumberValidation && errors.push("Phone number must be a valid number");
      return errors;
    },

    mobileErrors() {
      const errors = [];
      if (!this.$v.mobile_number.$dirty) return errors;
      !this.$v.mobile_number.required && errors.push("Mobile number is a required field");
      !this.$v.mobile_number.phoneNumberValidation && errors.push("Mobile number must be a valid number");
      return errors;
    },
  },

  watch: {
    account(newVal) {
      if (newVal) {
        this.first_name = this.account.first_name;
        this.last_name = this.account.last_name;
        this.email = this.account.email_address;
        this.phone_number = this.account.phone_number;
        this.mobile_number = this.account.mobile_number;

        this.auth_full_name = this.account.authorised_contact.name?this.account.authorised_contact.name:'';
        this.auth_email = this.account.authorised_contact.email_address?this.account.authorised_contact.email_address:'';
        this.auth_phone_number = this.account.authorised_contact.phone_number?this.account.authorised_contact.phone_number:'';
        this.auth_mobile_number = this.account.authorised_contact.mobile_number?this.account.authorised_contact.mobile_number:'';
      }
    }
  },

  methods: {
    ...mapActions("accounts", ["updateAccount"]),
    ...mapActions("alerts", ["setAlert"]),

    async save() {
      this.$v.$touch();

      if (!this.$v.$invalid) {

        let data = {
          first_name: this.first_name,
          last_name: this.last_name,
          email_address: this.email,
          phone_number: this.phone_number.replace(/\D/g, ""),
          mobile_number: this.mobile_number.replace(/\D/g, ""),
          authorised_contact: {
            name: this.auth_full_name!==''?this.auth_full_name:null,
            email_address: this.auth_email!==''?this.auth_email:null,
            phone_number: this.auth_phone_number!==''?this.auth_phone_number:null,
            mobile_number: this.auth_mobile_number!==''?this.auth_mobile_number:null,
          }
        };

        await this.updateAccount({ id: this.account.id, data });
        if(!this.getIsUpdateAccountError) {
          this.closeDialog();
        }
      }
    },

    setForm() {
      this.first_name = this.account.first_name;
      this.last_name = this.account.last_name;
      this.email = this.account.email_address;
      this.phone_number = this.account.phone_number;
      this.mobile_number = this.account.mobile_number;

      this.auth_full_name = this.account.authorised_contact.name?this.account.authorised_contact.name:'';
      this.auth_email = this.account.authorised_contact.email_address?this.account.authorised_contact.email_address:'';
      this.auth_phone_number = this.account.authorised_contact.phone_number?this.account.authorised_contact.phone_number:'';
      this.auth_mobile_number = this.account.authorised_contact.mobile_number?this.account.authorised_contact.mobile_number:'';
    },

    closeDialog(){
      this.close();
      this.$v.$reset();
      this.setForm();
    },
  }
};
</script>

<style lang="scss" scoped>
</style>
